import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { FaCheckCircle, FaTimesCircle, FaShippingFast, FaHourglassHalf } from 'react-icons/fa';
import './OrderStatus.css';
import { fetchOrderStatus } from '../../utils/orderService';
import OrderDetails from '../order/OrderDetails';

const OrderStatus = () => {
    const { orderId } = useParams();
    const [orderStatus, setOrderStatus] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const loadOrderStatus = async () => {
            try {
                const data = await fetchOrderStatus(orderId);
                setOrderStatus(data.orders[0]);
            } catch (error) {
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        loadOrderStatus();
    }, [orderId]);

    const renderStatusIcon = (status) => {
        switch (status) {
            case 'COMPLETED':
                return <FaCheckCircle className="status-icon completed" />;
            case 'SHIPPED':
                return <FaShippingFast className="status-icon shipped" />;
            case 'CANCELLED':
                return <FaTimesCircle className="status-icon cancelled" />;
            case 'PENDING':
                return <FaHourglassHalf className="status-icon pending" />;
            default:
                return null;
        }
    };

    if (loading) {
        return <div className="loading-circle"></div>;
    }

    if (error || !orderStatus) {
        return <p>Failed to fetch order status. Please try again later.</p>;
    }

    return (
        <div className="order-status">
            <h2>Order Status</h2>
            <OrderDetails orderStatus={orderStatus} renderStatusIcon={renderStatusIcon} />
        </div>
    );
};

export default OrderStatus;
